module.exports = __webpack_public_path__ + "static/img/broadcast-thumb-two.6d3944f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broadcast-thumb-two.png
// module id = glJB
// module chunks = 0